import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Button, Col, Input, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import { chartService } from 'services';
import { LeadService } from 'services/leads.service';
import { salesAreaService } from 'services/sales.area.service';

export default function LeadScore(props) {
    const [sources, setSources] = React.useState([]);
    const [wasSubmitted, setWasSubmitted] = useState([]);
    const [successMap, setSuccessMap] = useState([]);
    const [errorMap, setErrorMap] = useState([]);
    const [isRefreshing, setRefreshing] = useState(false);
    const [isModalOpen, setModalOpen] = useState(false);
    const [selectedSource, setSelectedSource] = useState(null);
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [timer, setTimer] = useState(null);
    const [filteredDeals, setFilteredDeals] = useState([]);
    const [matchedDeals, setMatchedDeals] = useState(null);
    const [isFetchingDeals, setIsFetchingDeals] = useState(true);
    const [expenditure, setExpenditure] = useState(0);
    const [salesAreas, setSalesAreas] = useState([]);
    const [selectedSalesArea, setSelectedSalesArea] = useState("0");
    const [regionPricing, setRegionPricing] = useState([]);

    useEffect(() => {
        getLeadSources();
        salesAreaService.getAll().then(resp => {
            setSalesAreas(resp);
        })
        LeadService.getRegionPricing().then(resp => {
            console.log(resp)
            if (resp.Success) {
                setRegionPricing(resp.Data);
            }
        })
    }, [])

    useEffect(() => {
        if (selectedSource == null) {
            setMatchedDeals(null);
            return;
        }
        var leadCount = filteredDeals.filter(d => {
            return d.LeadSource == selectedSource?.ExternalID;
        })
        setMatchedDeals(leadCount)
    }, [filteredDeals, selectedSource])

    useEffect(() => {
        if (filteredDeals) {
            setIsFetchingDeals(false);
        } else {
            setIsFetchingDeals(true)
        }
    }, [filteredDeals])

    useEffect(() => {
        if (!startTime || !endTime) {
            return;
        }

        if (timer) {
            clearTimeout(timer);
        }
        setIsFetchingDeals(true);
        let t = setTimeout(() => {
            chartService.getDealsByCreatedDate(startTime,endTime).then(resp => {
                if (resp?.Success) {
                    setFilteredDeals(resp.Data);
                } else {
                    //it failed
                }
            })
        }, 2000)
        setTimer(t)
    }, [startTime, endTime])

    const getLeadSources = () => {
        setMatchedDeals(null);
        LeadService.getSources().then(resp => {
            if (resp && resp.Success) {
                var sorted = resp.Data.sort((a, b) => {
                    return a.Name.toLowerCase() < b.Name.toLowerCase() ? -1 : 1;
                })
                setSources(sorted)
            }
        }).catch((err) => {
            console.error(err)
        })
    }

    const changeValue = (item, field, event) => {
        if (selectedSalesArea != 0 && field == 'Price') {
            //update the region pricing data
            var found = false;
            var newRegionData = regionPricing.map(i => {
                if (i.LeadSourceID == item.ID && i.RegionID == selectedSalesArea) {
                    found = true;
                    i[field] = parseFloat(event.target.value) || 0
                }
                return i;
            })
            if (!found) {
                newRegionData.push({
                    LeadSourceID: parseInt(item.ID),
                    RegionID: parseInt(selectedSalesArea),
                    Price: parseFloat(event.target.value)
                })
            }
            setRegionPricing(newRegionData);
        } else {
            //update the sources data
            var newSources = sources.map(i => {
                if (i.ID == item.ID) {
                    i[field] = parseFloat(event.target.value) || 0;
                    return i;
                }
                return i;
            })
            setSources(newSources);
        }
        if (wasSubmitted.indexOf(item.ID) !== -1) {
            setWasSubmitted(wasSubmitted.filter(i => {
                return i !== item.ID;
            }))
        }
        if (successMap.indexOf(item.ID) !== -1) {
            setSuccessMap(successMap.filter(i => {
                return i !== item.ID;
            }))
        }
        if (errorMap.indexOf(item.ID) !== -1) {
            setErrorMap(errorMap.filter(i => {
                return i !== item.ID;
            }))
        }
    }

    const refreshFromPipedrive = () => {
        if (isRefreshing) {
            return;
        }
        setRefreshing(true);
        LeadService.refreshSources().then(() => {
            setTimeout(() => {
                setRefreshing(false);
                getLeadSources();
            }, 60000)
        }).catch(() => {
            setRefreshing(false);
            getLeadSources();
        })
    }

    const updateItem = (item) => {
        if (wasSubmitted.indexOf(item.ID) !== -1) {
            return;
        }
        setWasSubmitted([...wasSubmitted, item.ID])
        //if settinng a sales area the endpoint and data payload is different
        if (selectedSalesArea == 0) {
            //set the default costing
            LeadService.updateSources(item).then(resp => {
                setSuccessMap([...successMap, item.ID])
            }).catch(err => {
                console.error(err);
                setErrorMap([...errorMap, item.ID])
            })
        } else {
            //set the costing based on the sales area
            var regionItem = regionPricing.find(i => {
                return i.RegionID == selectedSalesArea && i.LeadSourceID == item.ID;
            });
            if (regionItem) {
                //onnly submit if this region has a price set
                LeadService.setRegionPricing(regionItem).then(resp => {
                    setSuccessMap([...successMap, item.ID])
                }).catch(err => {
                    console.error(err);
                    setErrorMap([...errorMap, item.ID])
                })
            } else {
                setErrorMap([...errorMap, item.ID]);
            }
        }
    }

    const openModal = (item) => {
        setSelectedSource(item);
        setModalOpen(true);
    }

    const closeModal = () => {
        setSelectedSource(null);
        setModalOpen(false);
    }

    const toggleModal = () => {
        if (isModalOpen) {
            closeModal();
        }
    }

    const updateTime = (type, value) => {
        if (type == 'start') {
            setStartTime(value);
        } else if (type == 'end') {
            setEndTime(value);
        }
    }

    const changeSalesArea = (event) => {
        setSelectedSalesArea(event.target.value);
    }

    const updateExpenditure = (deals, cost) => {
        LeadService.setExpenditure({Deals: deals.map(d => d.DealID), Cost: cost})
        .then(resp => {
            setModalOpen(false);
        })
    }

    return (
        <div className="content">
            <h1 style={{textAlign: 'center'}}>Lead Source Scoring / Pricing</h1>
            <div className="row">
                <Button disabled={isRefreshing} pattern="[0-9]*" onClick={refreshFromPipedrive} >Update Lead Sources from Pipedrive</Button>
            </div>
            <div className="row">
                <div>
                    <Label>Sales Area To Configure</Label>
                    <select onChange={changeSalesArea} value={selectedSalesArea}>
                        <option value="0">Default</option>
                        {
                            salesAreas.map(sa => {
                                return <option key={`key-sa-${sa.ID}`} value={sa.ID}>{sa.Name}</option>
                            })
                        }
                    </select>
                </div>
            </div>
            <div style={{marginTop: "50px"}}>
                <table style={{width: '100%', maxWidth: '800px', margin: 'auto'}}>
                    <thead>
                        <tr>
                            <td><h3>Lead Source</h3></td>
                            <td><h3>Score</h3></td>
                            <td><h3>Price</h3></td>
                            <td><h3>&nbsp;</h3></td>
                            <td><h3>&nbsp;</h3></td>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            sources.map(l => {
                                var cost = l.Price;
                                if (selectedSalesArea != 0) {
                                    var saCost = regionPricing.find(rp => {
                                        return rp.LeadSourceID == l.ID && rp.RegionID == selectedSalesArea
                                    })
                                    cost = saCost ? saCost.Price : 0;
                                }
                                return (
                                    <tr key={`cost-ls-${l.ID}`}>
                                        <td style={{padding: '5px', color: 'white'}}>{l.Name}</td>
                                        <td style={{padding: '5px'}}><Input type="number" value={parseInt(l.Score).toString()} onChange={(e) => changeValue(l, 'Score', e)} /></td>
                                        <td style={{padding: '5px'}}>
                                            <Input type="number" value={parseFloat(cost).toString()} onChange={(e) => changeValue(l, 'Price', e)} /></td>
                                        <td style={{padding: '5px'}}>
                                            {
                                                errorMap.indexOf(l.LeadRawID) !== -1 && <div>Error</div>
                                            }
                                            {
                                                successMap.indexOf(l.LeadRawID) !== -1 && <div>Success</div>
                                            }
                                            <Button disabled={wasSubmitted.indexOf(l.ID) !== -1} onClick={() => updateItem(l)}>Update</Button>
                                        </td>
                                        <td style={{padding: '5px'}}>
                                            <Button onClick={() => openModal(l)}>Expenditure</Button>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
            <Modal isOpen={isModalOpen} toggle={toggleModal}>
                <ModalHeader>Add Expenditure for the Dates Below For {selectedSource?.Name }</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col>
                            <Label>Start Date (inclusive)</Label>
                            <input value={startTime} onChange={(e) => updateTime('start', e.target.value)} type="date"></input>
                        </Col>
                        <Col>
                            <Label>Ennd Date (Exclusive)</Label>
                            <input value={endTime} onChange={(e) => updateTime('end', e.target.value)} type="date"></input>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                        {
                            matchedDeals != null && <div>{matchedDeals.length} leads found during the preiod for {selectedSource?.Name}</div>
                        }
                        {
                            matchedDeals == null && <div>Loading deals created through that period</div>
                        }
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Label>Expenditure</Label>
                            <Input style={{color: 'black'}} type="number" value={parseInt(expenditure).toString()} onChange={e => setExpenditure(e.target.value)}></Input>
                        </Col>
                    </Row>
                    {matchedDeals && matchedDeals.length > 0 &&
                        <>
                            <Row>
                                <Col>
                                {Math.ceil(expenditure / matchedDeals.length * 100) / 100} is the average cost per lead
                                </Col>
                            </Row>
                        </>
                    }
                    {
                        matchedDeals && matchedDeals.length == 0 &&
                        <>
                            <Row>
                                <Col>
                                    Cannot devide by 0, no deals will be updated
                                </Col>
                            </Row>
                        </>
                    }
                    { matchedDeals &&
                        <Row>
                            <Col>
                                <Button disabled={isFetchingDeals} onClick={() => updateExpenditure(matchedDeals, Math.ceil(expenditure / matchedDeals.length * 100) / 100)}>Update {matchedDeals?.length} deals</Button>
                            </Col>
                        </Row>
                    }
                </ModalBody>
            </Modal>
        </div>
    )

}
